import { render } from "./NoteChat.vue?vue&type=template&id=60e60e66&scoped=true"
import script from "./NoteChat.vue?vue&type=script&lang=js"
export * from "./NoteChat.vue?vue&type=script&lang=js"

import "./NoteChat.vue?vue&type=style&index=0&id=60e60e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e60e66"]])

export default __exports__